import { useMemo, useReducer } from 'react';

import FlotiqPlugins from '../lib/flotiq-plugins/flotiqPluginsRegistry';

const usePluginResults = (
  eventName: string,
  EventClass: any,
  params: Record<string, any> = {},
  pluginId?: string,
) => {
  const [counter, addToCounter] = useReducer((count) => {
    return count + 1;
  }, 0);

  const results = useMemo(
    () => {
      const event = new EventClass({
        ...params,
        rerender: addToCounter,
      });

      return (
        (pluginId
          ? FlotiqPlugins.runScoped(eventName, pluginId, event)
          : FlotiqPlugins.run(eventName, event)) || []
      ).filter((r: any) => !!r);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/use-memo
    [EventClass, eventName, counter, ...Object.values(params)],
  );

  return results;
};

export default usePluginResults;
